(function () {
  'use strict';

  var language = (document.documentElement.lang || '').toLowerCase();
  if (language.indexOf('fr') !== 0) return;

  var reviewSelectors = [
    '.jdgm-prev-badge__text',
    '.jdgm-rev-widg__summary-text',
    '[data-rating-caption]'
  ].join(',');

  function translateReviewLabel(element) {
    var label = String(element.textContent || '').trim();
    var match;

    if (/^(no reviews?|no reviews? yet)$/i.test(label)) {
      element.textContent = 'Aucun avis';
      return;
    }

    match = label.match(/^(\d+)\s+reviews?$/i);
    if (match) {
      element.textContent = match[1] === '1' ? '1 avis' : match[1] + ' avis';
    }
  }

  function translateReviewLabels(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll(reviewSelectors), translateReviewLabel);

    if (scope && scope.matches && scope.matches(reviewSelectors)) {
      translateReviewLabel(scope);
    }
  }

  function start() {
    translateReviewLabels(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === 'characterData' &&
          mutation.target.parentElement &&
          mutation.target.parentElement.matches(reviewSelectors)
        ) {
          translateReviewLabel(mutation.target.parentElement);
        }

        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (
            (node.matches && node.matches(reviewSelectors)) ||
            (node.querySelector && node.querySelector(reviewSelectors))
          ) {
            translateReviewLabels(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
